import React, {useCallback, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Link, useHistory, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import axios from "axios";

import {useBackNavigation} from "components/BackButton";
import {Layout} from "components/Layout";
import {getSchoolRegion} from "helpers/regions";
import {SchoolInvitations} from "components/schools/SchoolInvitations";

/**
 * @api {get} /schools список школ
 * @apiGroup schools and classes
 * @apiName список школ
 *
 * @apiDescription <p>Страница со списком школ</p>
 * <p>Компонент <code>Schools.js</code> <a href="../client/src/pages/schools/Schools.js">ссылка на файл</a></p>
 */

/**
 * @api {get} /meetings/schools список школ при создании встречи
 * @apiGroup meetings
 * @apiName список школ при создании встречи
 *
 * @apiDescription <p>Страница со списком школ при создании встречи</p>
 * <p>Компонент <code>Schools.js</code> <a href="../client/src/pages/schools/Schools.js">ссылка на файл</a></p>
 */

export const Schools = () => {
    const { t } = useTranslation("schools");
    const { user } = useSelector((state) => state.auth);
    const history = useHistory();
    const location = useLocation();
    const [schools, setSchools] = useState([]);
    const schoolRegion = getSchoolRegion(user);
    const goBack = useBackNavigation();
    const isMeetingContext =
        location.pathname.indexOf("/meetings") !== -1 ||
        new URLSearchParams(location.search).get("context") === "meetings";

    const loadSchools = useCallback(async () => {
        const { data } = await axios.get("schools");
        setSchools(data);
    }, []);

    useEffect(() => {
        loadSchools();
    }, [loadSchools]);

    const handleInvitationAccepted = () => {
        // Обновляем список школ после принятия приглашения
        loadSchools();
    };

    return (
        <Layout>
            <div className="page">
                <header className="page__header">
                    <button
                        onClick={() => {
                            if (isMeetingContext) {
                                if (history.length > 1) {
                                    goBack();
                                } else {
                                    history.replace("/meetings");
                                }
                            } else {
                                history.push("/dashboard");
                            }
                        }}
                        className="icon-btn page__icon-btn page__icon-btn_left icon-btn_back"
                    />
                    <p className="page__title">{t("schools")}</p>
                </header>

                <Link
                    to={isMeetingContext ? "/pupils?context=meetings" : "/pupils?from=pupils"}
                    className="main-btn"
                    style={{ marginBottom: "2rem" }}
                >
                    {t("find_pupil")}
                </Link>

                {/* Секция приглашений */}
                <SchoolInvitations onInvitationAccepted={handleInvitationAccepted} />

                <div className="school-page__wrapper">
                    <div className="list">
                        {schools.map((school) => {
                            const targetPath = isMeetingContext
                                ? `${location.pathname}/${school._id}/classes?context=meetings`
                                : `${location.pathname}/${school._id}/classes`;

                            return (
                                <Link
                                    key={school._id}
                                    className="list__item"
                                    to={targetPath}
                                >
                                    <p>{school.name}</p>
                                    <p className="list__desc">{schoolRegion}</p>
                                </Link>
                            );
                        })}
                    </div>
                </div>
                <Link to="/schools/create" className="main-btn">
                    {t("add_my_organisation")}
                </Link>
            </div>
        </Layout>
    );
};
